import { render } from "./FavoritesMobile.vue?vue&type=template&id=a92a17e2&scoped=true"
import script from "./FavoritesMobile.vue?vue&type=script&lang=js"
export * from "./FavoritesMobile.vue?vue&type=script&lang=js"

import "./FavoritesMobile.vue?vue&type=style&index=0&id=a92a17e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92a17e2"]])

export default __exports__